module.exports = __webpack_public_path__ + "img/4-2.5e61c8ff.svg";